import React from 'react';
import './style.css';

const FloatingHearts = () => {
  // Tạo array các trái tim với thuộc tính ngẫu nhiên
  const hearts = Array.from({ length: 15 }, (_, i) => ({
    id: i,
    left: Math.random() * 100, // vị trí ngang (%)
    delay: Math.random() * 5, // delay animation (giây)
    duration: 8 + Math.random() * 7, // thời gian bay (8-15 giây)
    size: 12 + Math.random() * 18, // kích thước (12-30px)
    opacity: 0.3 + Math.random() * 0.4, // độ trong suốt (0.3-0.7)
  }));

  return (
    <div className="floating-hearts-container">
      {hearts.map((heart) => (
        <div
          key={heart.id}
          className="floating-heart"
          style={{
            left: `${heart.left}%`,
            animationDelay: `${heart.delay}s`,
            animationDuration: `${heart.duration}s`,
            fontSize: `${heart.size}px`,
            opacity: heart.opacity,
          }}
        >
          ♥
        </div>
      ))}
    </div>
  );
};

export default FloatingHearts;
